import React  from "react";
import { useParams } from 'react-router-dom';
import SettingForm from "./components/SettingForm";
import Card from "components/card";

const EditClientSetting = () => {

	const { clientId, settingId } = useParams();

	return (
	    <div>
	    	<Card extra={"w-full h-full p-4"}>
				<div className="mt-5 grid h-full grid-cols-1 gap-4">
      				<SettingForm 
						clientId={clientId} 
						recordId={settingId} 
						mode="edit"
					/>
	      		</div>
	    	</Card>
	    </div>
    );
};

export default EditClientSetting;